@let departmentsVal = sortedDepartments();
@let memberDataVal = memberData();

@if (memberDataVal) {
  <rt-dialog-body variant="white" layout-vertical>
    @if (noDepartments()) {
      <div class="empty-state">
        <rt-empty-state
          [title]="'tlc.members.edit_member.departments_tab.no_departments.title' | translate"
          [desc]="'tlc.members.edit_member.departments_tab.no_departments.desc' | translate"
          [icon]="'departments-hierarchy-tree'"
        >
          <rt-button (click)="vm.openAddGroupsDialog(memberDataVal)" variant="primary">
            <rt-icon name="add" />
            {{ 'tlc.members.edit_member.departments_tab.add_departments' | translate }}
          </rt-button>
        </rt-empty-state>
      </div>
    } @else {
      <div class="toolbar">
        <rt-heading variant="dark">{{
          'tlc.members.edit_member.departments_tab.added_to_departments'
            | translate: { count: $safeNavigationMigration(departmentsVal?.length) }
        }}</rt-heading>
        <rt-button (click)="vm.openAddGroupsDialog(memberDataVal)" variant="primary">
          <rt-icon name="add" />
          {{ 'tlc.members.edit_member.departments_tab.add_departments' | translate }}
        </rt-button>
      </div>

      <div class="groups">
        <rt-box variant="default vertical no-padding">
          <div padding-lr>
            @for (department of departmentsVal; track department.guid; let isLast = $last) {
              @let isTeamManagedExternally = vm.isManagedExternally(department.managedBy);
              @let managedTooltipKey = vm.getManagedTooltipKey(department.managedBy);
              <div class="group">
                <div class="group-details">
                  <rt-avatar
                    type="icon"
                    iconName="departments-hierarchy-tree"
                    customIconBackgroundColor="colorAvatarGrayDark"
                    customIconColor="colorIconOncomponentDefault"
                    size="base"
                    shape="square"
                  />
                  <div class="group-name">
                    <div class="name-wrapper">
                      <rt-heading
                        ><rt-truncate>{{ department.name }}</rt-truncate></rt-heading
                      >
                    </div>
                  </div>
                </div>
                <div
                  [rtTooltip]="managedTooltipKey | translate"
                  [rtTooltipEnabled]="isTeamManagedExternally"
                  rtTooltipPosition="below"
                >
                  <rt-button
                    (click)="
                      !isTeamManagedExternally &&
                        vm.openRemoveMemberDialog(department, memberDataVal)
                    "
                    [disabled]="isTeamManagedExternally"
                    variant="plain"
                  >
                    <rt-icon name="close" />
                    {{ 'tlc.members.edit_member.departments_tab.remove_department' | translate }}
                  </rt-button>
                </div>
              </div>

              @if (!isLast) {
                <rt-divider />
              }
            }
          </div>
        </rt-box>
      </div>
    }
  </rt-dialog-body>
}
